import { FeedStateEvent } from "./_types.js";
class Announcer {
  constructor(config = {}) {
    this.politeness = config.politeness || "polite";
    this.element = document.createElement("div");
    this.element.setAttribute("aria-live", this.politeness);
    this.element.setAttribute("role", "status");
    this.element.classList.add("sr-only");
    this.textElement = document.createElement("p");
    this.element.appendChild(this.textElement);
    if (config.message) {
      this.announce(config.message);
    }
  }
  /**
   * Announce a message to screen readers
   */
  announce(message) {
    this.textElement.textContent = message;
    this.element.dispatchEvent(
      new CustomEvent(FeedStateEvent.ANNOUNCEMENT, {
        bubbles: true,
        detail: {
          message,
          politeness: this.politeness,
          timestamp: Date.now()
        }
      })
    );
  }
  /**
   * Clear the announcement
   */
  clear() {
    this.textElement.textContent = "";
  }
  /**
   * Change the politeness level
   */
  setPoliteness(politeness) {
    this.politeness = politeness;
    this.element.setAttribute("aria-live", politeness);
  }
  /**
   * Remove the announcer from DOM
   */
  destroy() {
    if (this.element.parentNode) {
      this.element.remove();
    }
  }
  /**
   * Get the announcer element
   */
  getElement() {
    return this.element;
  }
}
export {
  Announcer
};
//# sourceMappingURL=announcer.js.map
